import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface DeleteLeaseDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  contractNumber: string
  onConfirm: () => void
  isDeleting: boolean
}

export function DeleteLeaseDialog({
  open,
  onOpenChange,
  contractNumber,
  onConfirm,
  isDeleting,
}: DeleteLeaseDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Lease Contract</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete lease contract{' '}
            <span className="font-mono font-semibold">{contractNumber}</span>? This
            action cannot be undone. The contract will be soft-deleted and can
            be restored by an administrator.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
